import { combineReducers } from 'redux';
// import loading from './loading_reducer';
import document_type_filter from './document_type_filter_reducer';

export default combineReducers( {
	                                document_type_filter
                                } );
